<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <div class="row">
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Fecha Inicio</div>
        <div>{{ $dateBackToFront(detailSections.startDate) }}</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Fecha Fin</div>
        <div>{{ $dateBackToFront(detailSections.endDate) }}</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Usuario conf</div>
        <div>{{ detailSections.userApplication || "-" }}</div>
      </div>
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Usuario firma</div>
        <div>{{ detailSections.userApprove || "-" }}
        </div>
      </div>
    </div>

    <div class="row mt-1 pb-1">
      <div class="col-3 mb-3">
        <div class="generalTitleItemModal">Estado</div>
        <div
          v-bind:class="{ 'border-success text-success': detailSections.status == 'confirmed', 'border-danger text-danger': detailSections.status == 'denied', 'border-info text-info': detailSections.status == 'pending', 'border-dark text-muted': detailSections.status == 'disabled', }"
          class="badge border text-uppercase">{{ detailSections.status || "-" }}</div>
      </div>
    </div>
    <div class="overflow-auto">      
      <table class="table mt-3">
        <thead>
          <tr class="tableRow">
            <th class="align-middle py-4 col-4">Desde</th>
            <th class="align-middle py-4 col-4">Hasta</th>
            <th class="align-middle py-4 col-4">Puntuación</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tableRow" v-for="(section, index) in detailSections.productRatings" :key="index">
            <td class="align-middle py-4 col-4">{{ section.since }}</td>
            <td class="align-middle py-4 col-4">{{ section.until }}</td>
            <td class="align-middle py-4 col-4">{{ section.rating }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../Shared/Modal.vue';
import axios from 'axios';

export default {
  name: 'ExportData',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'indexRating',
  ],
  data() {
    return {
      classes: this.class,
      detailSections: {},
    };
  },
  updated() {
    this.loadRatingDetail();
  },
  components: {
    Modal
  },
  methods: {
    loadRatingDetail() {
      axios.get(`/application-product-rating/${this.indexRating}`)
        .then((response) => {
          this.detailSections = response.data
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.confirmA {
  color: green;
  padding: 15px;
}

.denegateA {
  color: red;
  padding: 15px;
}

.actionsSuperuse {
  text-align: center;
}
</style>
